export default __webpack_public_path__ + "static/media/ri_creative-commons-nc-line.81a6ef55.svg";